import Vue from 'vue'
import requisitionTransformer from '@/transformers/catalog/warehouse/requisitionSM'

/**
 * @author jorge nuñez lópez <>
 *
 * Make requisition from SM list
 * @param payload supplies information
 * @return {object}
 */

export default (supplies, iwarehouseId) => {
  const payload = requisitionTransformer.sendCollection(supplies)
  return Vue.$http.post(`iwarehouse/${iwarehouseId}/requisition/create/`, { data: payload })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/sendRequisitionSM.js